import { useParams } from "react-router";

import { UserFlagsTable } from "@/user/components/UserFlagsTable";
import { useUserFlagsData } from "@/user/data/useUserFlagsData";

export default function UserFlags() {
  const { userId } = useParams();

  const { data, isLoading, isFetching, isError, refetch } =
    useUserFlagsData(userId);

  return (
    <UserFlagsTable
      data={data}
      isError={isError}
      isFetching={isFetching}
      isLoading={isLoading}
      onRetry={refetch}
    />
  );
}
